import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { capitalize } from "@mui/material";
import { SendPostRequest } from "../../../http";
import Spinner from "../../Spinner";
import HeaderWrapper from "../../Header/HeaderWrapper";
import FooterWrapper from "../../Footer/FooterWrapper";
import { limitParagraphByCharLimit } from "../../../Helper/Helper";
import TextMainBannerWrapper from "../../TextMainBanners/TextMainBannerWrapper";

function BoxDuoServicesListing() {
  const sitedata = useSelector((store) => store.global.loginData);
  const [isLoading, setIsLoading] = useState(true);
  const [isData, setIsdata] = useState(false);
  const [servicesData, setServicesData] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    getServicesData();
  }, []);

  const getServicesData = async () => {
    const response = await SendPostRequest("services/list");
    setIsLoading(false);

    if (!response?.data || response?.data?.length < 1) {
      setIsdata(true);
    } else {
      setServicesData(response.data);
    }
  };

  return (
    <div className="page-wrapper-inner">
      <div className="page-wrapper-inner">
        <HeaderWrapper />

        <TextMainBannerWrapper
          Heading={sitedata?.site_type === "hospitals" ? "Our Specialties" : "Services"}
          Image="theme-2-banner-speciality.webp"
        />


        <div className="container">
             {sitedata?.site_type === "hospitals" ? (
            <div className="row mt-5">
              <div className="offset-md-2 col-md-8">
                <div className="title-wrap text-center">
                  <div className="section-title margin-bottom-60">
                    <h2 className="section-title mb-0 text-uppercase">
                      Provides Our{" "}
                      <span className="theme-color">Best Specialties</span>
                    </h2>
                    <span className="section-border-bottom center"></span>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="mt-5"></div>
          )}

         <div className="row my-3">
            {isLoading ? (
              <div className="col-12 text-center">
                <Spinner />
              </div>
            ) : isData ? (
              <div className="col-12 text-center mb-4">
                <h4>No Record Available</h4>
              </div>
            ) : (
              servicesData.map((service, index) => (
                <div className="col-lg-4 mb-4 item" key={index}>
                  <div className="feature-box-wrap f-box-style-6 relative duo-box-home-height">
                    <div className="feature-box-details h-100">
                      <div className="feature-img">
                        <img
                          className="img-fluid"
                          src={service?.service_image_url}
                          style={{ height: "auto" }}
                          width="425"
                          alt="feature img"
                        />
                      </div>
                      <div className="feature-content mt-4 mb-2">
                        <div className="feature-title relative margin-bottom-5">
                          <h5>{service?.service_title}</h5>
                        </div>
                        <p className="mb-0" style={{ lineHeight: "24px" }}>
                          <div
                            className="service-desc mb-2"
                            dangerouslySetInnerHTML={{
                              __html:
                                limitParagraphByCharLimit(service?.service_short_description, 55) +
                                (service?.service_short_description?.length > 55 ? "..." : ""),
                            }}
                          />
                        </p>
                      </div>
                      <div className="button">
                        <Link
                          className="btn-link"
                          to={`/${sitedata?.site_type === "hospitals" ? "speciality" : "service"}/${service?.uid}/${service?.service_title
                            .replaceAll(" ", "-")
                            .replaceAll("/", "-")}`}
                        >
                          Read More
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
        <FooterWrapper />
      </div>
    </div>
  );
}

export default BoxDuoServicesListing;
